/* @ngInject */
const autocomplete = (
  matcher,
  $filter,
  valueHandler,
) => {
  return (values, filter) => {
    if (!valueHandler.isArray(values)) return []
    if (!valueHandler.isString(filter)) return values

    const filtered = []
    for (const value of values) {
      if (matcher.contain($filter('noSpecialChar')(value), '' + filter))
        filtered.push(value)
      if (value === filter) {
        return values
      }
    }
    return filtered
  }
}

export default autocomplete



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/utils/autocomplete.filter.js